import moment from 'moment';

// Period filter shared by every list. The list APIs ignore date parameters, so a period is built by reading
// pages (newest first) until the rows get older than the cut-off, then filtering and paging on the page.
export const RANGES = ['7', '15', '30', '90', 'all'];
export const DEFAULT_RANGE = '30';

export const cutoffOf = (range) => (range === 'all' ? null : moment().startOf('day').subtract(Number(range), 'days'));

const within = (row, key, cutoff) => Boolean(row[key]) && !moment(row[key]).isBefore(cutoff);

// fetchPage(pageNo, pageSize) -> array of rows (newest first). Stops when a page is entirely older than the cut-off
// (or, for lists that are sorted by number rather than date, when a page has nothing inside the period).
export const loadRange = async ({
  fetchPage, dateKey, range, pageSize = 100, maxPages = 40,
}) => {
  const cutoff = cutoffOf(range);
  const rows = [];
  for (let page = 1; page <= maxPages; page += 1) {
    // eslint-disable-next-line no-await-in-loop
    const list = await fetchPage(page, pageSize);
    const inside = list.filter((r) => within(r, dateKey, cutoff));
    rows.push(...inside);
    const dates = list.map((r) => r[dateKey]).filter(Boolean);
    const sorted = dates.every((d, i) => i === 0 || d <= dates[i - 1]);
    const last = dates[dates.length - 1];
    if (list.length < pageSize) break;
    if (sorted && last && moment(last).isBefore(cutoff)) break;
    if (inside.length === 0) break;
  }
  return rows;
};

// Slice already-loaded rows into a page and describe it the way the API's paginationData does.
export const paginate = (rows, pageNo, size) => ({
  list: rows.slice((pageNo - 1) * size, pageNo * size),
  pagination: {
    currentPage: pageNo, totalPages: Math.max(1, Math.ceil(rows.length / size)), totalRecords: rows.length,
  },
});
